/**
 * Card rating badge – uses shared getSeededSocialProof (social-proof-utils.js).
 * Same seeded rating/count as product page; min-max from theme settings.
 * Include on collection, featured-collection, search templates that render card-product.
 */
(function () {
  'use strict';

  function initCardRatings() {
    if (typeof window.getSeededSocialProof !== 'function') return;
    const badges = document.querySelectorAll('.card__rating-badge[data-product-id]');
    badges.forEach(function (el) {
      const pid = el.getAttribute('data-product-id');
      if (!pid) return;
      const valueEl = el.querySelector('.card__rating-value');
      const countEl = el.querySelector('.card__rating-count');
      const data = window.getSeededSocialProof(pid);
      if (valueEl) valueEl.textContent = data.rating.toFixed(1);
      if (countEl) countEl.textContent = data.ratingCount;
    });
  }

  // Expose globally for infinite scroll / section reload to re-init new cards
  window.initCardRatings = initCardRatings;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCardRatings);
  } else {
    initCardRatings();
  }
})();
